module.exports = __webpack_public_path__ + "static/media/dark-green-chevron-down.a9c3b847.svg";